import { FC } from 'react'
import { Autocomplete, FormControl, Grid, TextField } from '@mui/material'
import { FormikProps } from 'formik'
import { useIntl, FormattedMessage } from 'react-intl'
import { StyledCard, StyledCardContent, StyledCardHeader } from './styledComponents'

interface Props {
  formik: FormikProps<any>
  order: any
  customers: { id: string; name: string; emails: null | string[] }[]
  assignees: { id: string; firstName: string; lastName: string }[]
  isCustomer: boolean | string | undefined
  permission: (field: string) => boolean
}

const CustomerDetailsSection: FC<Props> = ({
  formik,
  order,
  customers,
  assignees,
  isCustomer,
  permission,
}) => {
  const intl = useIntl()

  if (!permission('customer')) return null

  return (
    <StyledCard>
      <StyledCardHeader title={<FormattedMessage id="customer-details" />} />
      <StyledCardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <Autocomplete
                options={customers}
                getOptionLabel={(option) => option.name}
                onChange={(event, value) => formik.setFieldValue('customer', value?.id)}
                defaultValue={order?.customer}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={intl.formatMessage({ id: 'customer' })}
                    name="customer"
                    error={formik.touched.customer && Boolean(formik.errors.customer)}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <Autocomplete
                options={assignees}
                getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
                onChange={(event, value) => formik.setFieldValue('assignee', value?.id)}
                defaultValue={order?.assignee}
                disabled={!!isCustomer}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={intl.formatMessage({ id: 'assignee' })}
                    name="assignee"
                    error={formik.touched.assignee && Boolean(formik.errors.assignee)}
                  />
                )}
              />
            </FormControl>
          </Grid>
        </Grid>
      </StyledCardContent>
    </StyledCard>
  )
}

export default CustomerDetailsSection
